import { Checkbox, FormControlLabel, Grid, InputAdornment, Paper, TextField } from '@material-ui/core'
import { DateTimePicker } from '@material-ui/pickers';
import { Moment } from 'moment';
import React, { useEffect, useState } from 'react'
import { useStressEntryContext } from './StressEntryContext';
import { STRESSOR_CHECK_IN_MODE, STRESSOR_CHECK_OUT_MODE } from './constants';

export const PidFields = () => {

    const [formData, setFormData] = useState({
        Calibration_date: null as Moment | null,
        Test_duration: "",
        Test_humidity: "",
        Test_temperature: "",
        Voltage_is_normal: false,
    });

    const { state, dispatch } = useStressEntryContext();

    const handleDateChange = (date: Moment | null) => {
        setFormData(prev => ({ ...prev, Calibration_date: date }));
    };

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));

    };
    const handleCheckboxChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, checked } = e.target;
        setFormData(prev => ({ ...prev, [name]: checked }))
    }
    useEffect(() => {
        const payload = {
            Calibration_date: formData.Calibration_date
                ? formData.Calibration_date.format("YYYY-MM-DD")
                : "",
            Test_duration: formData.Test_duration ? parseFloat(formData.Test_duration) : null,
            Test_humidity: formData.Test_humidity ? parseFloat(formData.Test_humidity) : null,
            Test_temperature: formData.Test_temperature ? parseFloat(formData.Test_temperature) : null,
            Voltage_is_normal: formData.Voltage_is_normal
        };
        console.log("Auto-updated payload:", payload);
       
        dispatch({ type: "PID_STRESS_DETAILS", payload });
    }, [formData, dispatch]);
    return (
        <div>

            {state.mode === STRESSOR_CHECK_OUT_MODE && state.isPidTestCheck && (
                <Paper elevation={3} style={{ padding: '20px', margin: '20px' }}>
                    <Grid
                        container
                        direction="row"
                        justifyContent="space-around"
                        alignItems="flex-start"
                        spacing={2}
                        style={{ marginTop: 16, marginBottom: 16 }}
                    >
                        <Grid item xs={6}>
                            <Grid container spacing={2}>
                                <Grid item xs={12} style={{ marginTop: 18 }}>
                                    <DateTimePicker
                                        label="Calibration Date"
                                        format="YYYY-MM-DD HH:mm"
                                        fullWidth
                                        value={formData.Calibration_date}
                                        onChange={handleDateChange}

                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    <TextField

                                        name="Test_duration"
                                        label="Test duration"
                                        type="number"
                                        value={formData.Test_duration}
                                        onChange={handleChange}
                                        fullWidth
                                        InputProps={{
                                            endAdornment: (
                                                <InputAdornment position="end">hours</InputAdornment>
                                            ),
                                        }}

                                    />

                                </Grid>
                                <Grid item xs={12}>
                                    <TextField

                                        name="Test_humidity"
                                        label="Test Humidity"
                                        type="number"
                                        value={formData.Test_humidity}
                                        onChange={handleChange}
                                        fullWidth
                                        InputProps={{
                                            endAdornment: (
                                                <InputAdornment position="end">%RH</InputAdornment>
                                            ),
                                        }}
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    <TextField

                                        name="Test_temperature"
                                        label="Test Temperature"
                                        type="number"
                                        value={formData.Test_temperature}
                                        onChange={handleChange}
                                        fullWidth
                                        InputProps={{
                                            endAdornment: (
                                                <InputAdornment position="end">°C</InputAdornment>
                                            ),
                                        }}
                                    />

                                </Grid>
                                <Grid item xs={12}>

                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                name="Voltage_is_normal"
                                                checked={formData.Voltage_is_normal}
                                                onChange={handleCheckboxChange}
                                            />
                                        }
                                        label="Voltage is normal"
                                    />
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Paper>
            )

            }
        </div>
    )
}


